import YachtSearchLink from './YachtSearchLink';

export default YachtSearchLink;
